<template>
	<v-container>
		<FormDaftar v-if="this.$session.get('role')==4" :data="{ editedItem }" :dataKota="{ search_kota }" :dataTanggal="{ search_tgl_daftar_raw }"></FormDaftar>
		<FormDaftarHuang v-if="this.$session.get('role')==5" :data="{ editedItem }"></FormDaftarHuang>
        <FormDaftarHuang v-if="this.$session.get('role')==9" :data="{ editedItem }"></FormDaftarHuang>
        <FormEditTaoUserVue v-if="this.$session.get('role')==7" :data="{ editedItem }"></FormEditTaoUserVue>
	</v-container>
</template>

<script type="text/javascript">
import FormDaftar from '../../components/modal/FormDaftarTaoUser.vue'
import FormDaftarHuang from '../../components/modal/FormDaftarHuangUser.vue'
import FormEditTaoUserVue from '../../components/modal/FormEditTaoUser.vue'
export default {
    name: 'UserRegis',
    components: {
        FormDaftar,
        FormDaftarHuang,
        FormEditTaoUserVue
    },
    mounted:function(){
    	// if(this)
    },
    data(){
        return {
     		editedItem: [],
     		search_kota: '',
     		search_tgl_daftar_raw: '',
        }
    }
}
</script>